import { types } from '../actions/actions';

// events: [{
//     id: new Date().getTime(),
//     title: 'Team meeting',
//     start: moment().toDate(),
//     end: moment().add(2, 'hours').toDate(),
//     notes: 'daily meeting',
//     user: {
//       _id: '123',
//       name: 'Fernando'
//     }
//   } ]

const initialState = {
    
    events: [],
      
    activeEvent: null
}


export const calendarReducer = ( state = initialState , action ) => {

    switch (action.type) {
       
        case types.setActiveEvent:
            return {
                ...state,
                activeEvent: action.payload }

        case types.addNewEvent:
            return{
                ...state,
                events: [...state.events, action.payload ]
            }

        case types.clearActiveEvent:
            return{
                ...state,
                activeEvent: null
            }    
    
        case types.eventUpdate:
            return{
                ...state,
                events: state.events.map(e => ( e.id === action.payload.id ) ? action.payload : e)
            }
        
        case types.deleteEvent:
            
            return{
                ...state,
                events: state.events.filter(e => (e.id !== state.activeEvent.id )),
                activeEvent: null
            } 
            
        case types.eventLoaded:
            return{
                ...state,
                events: [ ...action.payload ]
            }  
            
        case types.eventLogout:
            return {
                ...initialState
            }
        default:
            return state;
    }



}